export default __webpack_public_path__ + "static/media/installer-files1.60945139.jpg";